import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import SearchComponent from "../../components/search";
import Table from '../../components/datatable/datatable';
import CreateUserModal from "../../components/create-customer-modal";
import ViewCustomerProfileAdmin from "../../components/view-customer-admin";
import Dropdown from "../../components/dropdown";
import { adminGetAllUsers, changeCustomerStatus, deleteCustomers, updateCustomerTax, updateProfile, updateUserApiLimits } from "../../core/axios/endpoints";
import Papa from "papaparse";
import Swal from "sweetalert2";
import AdminUpdateCustomerTaxModal from "../../components/update-tax-model";
import AdminUpdateUserLimitsModal from "../../components/update-api-limits";
import PartnerConfigModal from "../../components/partner-config-modal";
import { hasAnyPartnerRole, isSubsidiePartner } from "../../core/partner-subsidie";

const AdminKlantenPage = (props) => {
    const [data, setData] = useState([]);
    const [userCounts, setUserCounts] = useState({
        allUsers: 0,
        activeUsers: 0,
        inactiveUsers: 0,
    });
    const [loading, setLoading] = useState(false);
    const [isEditOpen, SetisEditOpen] = useState(false);
    const [SelectedRows, setSeletedRows] = useState([]);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [userDetails, setUserDetails] = useState({});
    const navigate = useNavigate();
    const [isUpdateCostModalOpen, setIsUpdateCostModalOpen] = useState(false);
    const [applicationFee, setApplicationFee] = useState(0);
    const [applicationFees, setApplicationFees] = useState(null);
    const [selectedCustomerId, setSelectedCustomerId] = useState('');
    const [isUpdateLimitsModalOpen, setIsUpdateLimitsModalOpen] = useState(false);
    const [rateLimitHour, setRateLimitHour] = useState(5);
    const [rateLimitDay, setRateLimitDay] = useState(100);
    const [partnerConfigUser, setPartnerConfigUser] = useState(null);
    const closeDropdown = (record) => {
        document.getElementById(`dropdown-klanten-action-${record?.id}`)?.removeAttribute("open");
    }

    const RowChanges = (rows) => {
        setSeletedRows(rows)
    }

    const columns = [
        {
            title: "Naam",
            dataIndex: "naam",
            sorter: (a, b) => a.naam.localeCompare(b.naam),
        },
        {
            title: "Email",
            dataIndex: "email",
            sorter: (a, b) => a.email.localeCompare(b.email),
        },
        {
            title: "Bedrijf",
            dataIndex: "bedrijfsnaam",
            sorter: (a, b) => a.bedrijfsnaam.localeCompare(b.bedrijfsnaam),
        },
        {
            title: "Telefoonnummer",
            dataIndex: "telefoonnummer",
            sorter: (a, b) => a.telefoonnummer.localeCompare(b.telefoonnummer),
        },
        {
            title: "Profiel",
            dataIndex: "isProfileCompleted",
            render: (record) => (
                <span className={`inline-flex items-center rounded px-1.5 py-px text-[11px] font-bold uppercase tracking-wide ${record ? "bg-[#DCFFF1] text-[#1F845A]" : "bg-[#091E420F] text-ink-subtle"}`}>{record ? "Voltooid" : "Open"}</span>
            )
        },
        {
            title: "Partner",
            render: (record) =>
                hasAnyPartnerRole(record) ? (
                    <span
                        title={[
                            record?.btwPartnerEnabled ? "BTW Batterij" : null,
                            isSubsidiePartner(record) ? `Subsidie (${record.partnerModules.join(", ")})` : null,
                        ].filter(Boolean).join(" · ")}
                        className="inline-flex items-center gap-1 rounded bg-[#F3F0FF] px-1.5 py-px text-[11px] font-bold uppercase tracking-wide text-[#5E4DB2]"
                    >
                        <svg className="h-2.5 w-2.5" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3z" />
                        </svg>
                        Partner
                    </span>
                ) : (
                    <span className="text-xs text-ink-disabled">-</span>
                ),
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text) => (
                <span className={`inline-flex items-center rounded px-1.5 py-px text-[11px] font-bold uppercase tracking-wide ${text === "active" ? "bg-[#DCFFF1] text-[#1F845A]" : "bg-[#FFECEB] text-[#AE2A19]"}`}>{text}</span>
            ),
            sorter: (a, b) => a.status.localeCompare(b.status),
        },
        {
            title: "Action",
            render: (record) => (
                <Dropdown className="dropdown-action dropdown dropdown-end" id={"dropdown-klanten-action-" + record?.id}>
                    <summary className="inline-flex h-8 w-8 cursor-pointer list-none items-center justify-center rounded text-ink-subtlest hover:bg-[#091E420F] focus:outline-none">
                        <FeatherIcon icon="more-vertical" size={16} />
                    </summary>
                    <ul className="dropdown-content z-[1] flex w-fit min-w-[12rem] flex-col rounded bg-white p-1 shadow-overlay">
                        <Link onClick={() => { setUserDetails(record); closeDropdown(record); setIsViewModalOpen(true) }} className="link-ancher cursor-pointer whitespace-nowrap rounded px-2 py-1.5 text-sm text-ink hover:bg-[#091E420F]">
                            View
                        </Link>
                        <Link onClick={() => {
                            closeDropdown(record);
                            handleUserStatusUpdate(record._id, record.status === "active" ? "inactive" : "active");
                        }
                        } className="link-ancher cursor-pointer whitespace-nowrap rounded px-2 py-1.5 text-sm text-ink hover:bg-[#091E420F]">
                            Markeer {record.status === "active" ? "Inactief" : "Actief"}
                        </Link>
                        <Link onClick={() => {
                            closeDropdown(record);
                            openUpdateModal(record);
                        }
                        } className="link-ancher cursor-pointer whitespace-nowrap rounded px-2 py-1.5 text-sm text-ink hover:bg-[#091E420F]">
                            Update Kosten
                        </Link>
                        <Link onClick={() => { closeDropdown(record); openUpdateLimitsModal(record); }} className="link-ancher cursor-pointer whitespace-nowrap rounded px-2 py-1.5 text-sm text-ink hover:bg-[#091E420F]">
                            Update Limits
                        </Link>
                        <Link onClick={() => { closeDropdown(record); setPartnerConfigUser(record); }} className="link-ancher cursor-pointer whitespace-nowrap rounded px-2 py-1.5 text-sm text-[#5E4DB2] hover:bg-[#091E420F]">
                            {hasAnyPartnerRole(record) ? "Bewerk partner-config" : "Maak partner"}
                        </Link>
                    </ul>
                </Dropdown>
            ),
        },
    ];

    const fetchData = async ({ page, pageSize, resetPageSize }) => {
        try {
            setLoading(true);
            const response = await adminGetAllUsers(page, pageSize, searchText);
            const result = {
                data: response.docs.map((user, index) => ({ ...user, key: index })),
                totalDataCount: response.totalDocs,
                resetPageSize,
            };
            setUserCounts(response.userCounts);
            setData(result);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData({ page: 1, pageSize: 10, resetPageSize: false });
    }, [searchText]);

    const handleSearch = (query) => {
        setSearchText(query);
    };

    const handleDelete = async () => {
        Swal.fire({
            title: 'Weet je het zeker?',
            text: "Dit kan niet ongedaan worden gemaakt!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ja, verwijder het!',
            cancelButtonText: 'Annuleren'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteCustomers(SelectedRows);
                    fetchData({ page: 1, pageSize: 10, resetPageSize: false });
                    Swal.fire(
                        'Verwijderd!',
                        'De geselecteerde klanten zijn verwijderd.',
                        'success'
                    );
                } catch (error) {
                    console.error("Error deleting customers:", error);
                    Swal.fire(
                        'Mislukt!',
                        'Er is een fout opgetreden bij het verwijderen van de klanten.',
                        'error'
                    );
                }
            }
        });
    };

    const handleUserStatusUpdate = async (id, status) => {
        Swal.fire({
            title: 'Weet je het zeker?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ja, bijgewerkt het!',
            cancelButtonText: 'Annuleren'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await changeCustomerStatus(id, { status });
                    fetchData({ page: 1, pageSize: 10, resetPageSize: false });
                    Swal.fire(
                        'Bijgewerkt!',
                        'De geselecteerde klanten zijn Bijgewerkt.',
                        'success'
                    );
                } catch (error) {
                    console.error("Error deleting customers:", error);
                    Swal.fire(
                        'Mislukt!',
                        'Er is een fout opgetreden bij het bijgewerkt van de klanten.',
                        'error'
                    );
                }
            }
        });
    };

    const handleExport = () => {
        const csvData = data.data.map(row => ({
            ID: row._id,
            Naam: row.naam,
            Email: row.email,
            Telefoonnummer: row.telefoonnummer,
            Status: row.status,
            Rol: row.role,
            ApplicationFee: row.applicationFee,
            Tax: row.tax,
            IsProfileCompleted: row.isProfileCompleted,
            CreatedAt: new Date(row.createdAt).toLocaleString(),
            UpdatedAt: new Date(row.updatedAt).toLocaleString(),
            Adres: row.adres,
            Bedrijfsnaam: row.bedrijfsnaam,
            Plaats: row.plaats,
            Postcode: row.postcode,
            ProfielFoto: row.profielFoto,
            ApiHits: row.overallRequestCount,
        }));
        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "klanten.csv");
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const openUpdateModal = async (record) => {
        setApplicationFee(record?.applicationFee || 0);
        setApplicationFees(record?.applicationFees ?? null);
        setSelectedCustomerId(record._id);
        setIsUpdateCostModalOpen(true);
    };

    const openUpdateLimitsModal = async (record) => {
        setRateLimitHour(record?.rateLimitHour);
        setRateLimitDay(record?.rateLimitDay);
        setSelectedCustomerId(record._id);
        setIsUpdateLimitsModalOpen(true);
    };

    // Submit accepteert óf een number (legacy enkel applicationFee) óf een
    // object met per-module bedragen (nieuw: `{ eia, eiaZon, isde, btwBatterij }`).
    const UpdateCustomerTax = async (payload, priceScope) => {
        try {
            const body =
                typeof payload === "number"
                    ? { applicationFee: payload, tax: payload * 0.21 }
                    : { applicationFees: payload, ...(priceScope ? { priceScope } : {}) };
            await updateCustomerTax(selectedCustomerId, body);
            fetchData({ page: 1, pageSize: 10, resetPageSize: false });
            Swal.fire(
                'Bijgewerkt!',
                'De klanten kosten zijn bijgewerkt.',
                'success'
            );
        } catch (error) {
            console.error("Error updating customer tax:", error);
            Swal.fire(
                'Mislukt!',
                'Er is een fout opgetreden bij het bijwerken van de klanten kosten.',
                'error'
            );
        }
    }


    const handleSubmitLimits = async (limits) => {
        try {
            await updateUserApiLimits(selectedCustomerId, limits);
            fetchData({ page: 1, pageSize: 10, resetPageSize: false });
            Swal.fire(
                'Updated!',
                'The user rate limits have been updated.',
                'success'
            );
        } catch (error) {
            console.error("Error updating user rate limits:", error);
            Swal.fire(
                'Failed!',
                'An error occurred while updating the user rate limits.',
                'error'
            );
        }
    };

    return (
        <div className="page-wrapper">
            <div className="content admin-pages">
                <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
                    <div>
                        <nav className="mb-1 text-xs text-ink-subtlest" aria-label="Breadcrumb">
                            <Link to="/panel/admin/dashboard" className="hover:underline">Dashboard</Link>
                            <span className="mx-1">/</span>
                            <span>Administratie</span>
                            <span className="mx-1">/</span>
                            <span>Klanten</span>
                        </nav>
                        <h1 className="text-2xl font-medium text-ink">Klanten</h1>
                    </div>
                    <div className="flex flex-wrap items-center gap-2">
                        <button
                            type="button"
                            onClick={() => setIsCreateModalOpen(true)}
                            className="inline-flex h-8 items-center gap-1.5 rounded bg-brand px-3 text-sm font-medium text-white hover:bg-brand-hover"
                        >
                            <FeatherIcon icon="plus" size={16} />
                            Klant registreren
                        </button>
                    </div>
                </div>

                <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    <div className="rounded bg-white p-4 shadow-card">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Actieve klanten</p>
                        <p className="mt-2 text-2xl font-medium tabular-nums text-ink">{userCounts.activeUsers}</p>
                    </div>
                    <div className="rounded bg-white p-4 shadow-card">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Inactieve klanten</p>
                        <p className="mt-2 text-2xl font-medium tabular-nums text-ink">{userCounts.inactiveUsers}</p>
                    </div>
                    <div className="rounded bg-white p-4 shadow-card">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Alle klanten</p>
                        <p className="mt-2 text-2xl font-medium tabular-nums text-ink">{userCounts.allUsers}</p>
                    </div>
                    <div className="rounded bg-white p-4 shadow-card">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Overall Api Hits</p>
                        <p className="mt-2 text-2xl font-medium tabular-nums text-ink">{userCounts.overallRequestCount}</p>
                    </div>
                </div>

                <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
                    <div className="w-full max-w-md">
                        <SearchComponent onSearch={handleSearch} type={'users'} />
                    </div>
                    <div className="flex flex-wrap items-center gap-2">
                        <button
                            type="button"
                            disabled={!SelectedRows?.length}
                            className="inline-flex h-8 items-center gap-1.5 rounded bg-[#091E420F] px-3 text-sm font-medium text-ink hover:bg-[#091E4224] disabled:cursor-not-allowed disabled:opacity-50"
                            onClick={handleExport}
                        >
                            <FeatherIcon icon="download" size={16} />
                            Exporteer
                        </button>
                        <button
                            type="button"
                            disabled={!SelectedRows?.length}
                            className="inline-flex h-8 items-center gap-1.5 rounded bg-[#C9372C] px-3 text-sm font-medium text-white hover:bg-[#AE2A19] disabled:cursor-not-allowed disabled:opacity-50"
                            onClick={handleDelete}
                        >
                            <FeatherIcon icon="trash-2" size={16} />
                            Verwijder
                        </button>
                    </div>
                </div>

                <div className="table-responsive rounded bg-white shadow-card">
                    <Table
                        columns={columns}
                        response={data}
                        fetchData={fetchData}
                        SelectedRows={RowChanges}
                        loading={loading}
                    />
                </div>
            </div>
            <CreateUserModal isOpen={isCreateModalOpen} onClose={() => { setIsCreateModalOpen(false); fetchData({ page: 1, pageSize: 10 }) }} />
            <ViewCustomerProfileAdmin isOpen={isViewModalOpen} onClose={() => setIsViewModalOpen(false)} userDetails={userDetails} />
            <AdminUpdateCustomerTaxModal
                isOpen={isUpdateCostModalOpen}
                onSubmit={UpdateCustomerTax}
                applicationFees={applicationFees}
                legacyApplicationFee={applicationFee}
                onClose={() => { setIsUpdateCostModalOpen(false); fetchData({ page: 1, pageSize: 10 }) }}
            />
            <AdminUpdateUserLimitsModal
                isOpen={isUpdateLimitsModalOpen}
                onClose={() => { setIsUpdateLimitsModalOpen(false); fetchData({ page: 1, pageSize: 10, resetPageSize: false }); }}
                onSubmit={handleSubmitLimits}
                rateLimitHour={rateLimitHour}
                rateLimitDay={rateLimitDay}
            />
            <PartnerConfigModal
                isOpen={!!partnerConfigUser}
                user={partnerConfigUser}
                onClose={() => setPartnerConfigUser(null)}
                onSaved={() => {
                    fetchData({ page: 1, pageSize: 10, resetPageSize: false });
                }}
            />
        </div>
    );
};

export default AdminKlantenPage;
